import { Avatar } from '@mantine/core';

import UserAvatar from 'src/Components/NavBar/UserAvatar';

import { Props } from './ShareAvatar.types';

/**
 * Avatar for whoever bears an expense share.
 *
 * A share is borne by a registered member or by an unregistered co-owner. `UserAvatar` falls
 * back to the *current* user when given no user, so an unregistered co-owner must never be
 * routed through it — it would show the viewer's own face on someone else's share.
 */
const ShareAvatar = ({ share, size }: Props) => {
  if (share.user) {
    return <UserAvatar user={share.user} size={size} />;
  }

  const { firstName = '', lastName = '' } = share.placeholderMember ?? {};
  const initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();

  return <Avatar color="initials" size={size} name={initials} />;
};

export default ShareAvatar;
